import { create } from "zustand";
import type { IViewConfig } from "lola-framework-ui-test";
import type { IErrorState } from "../shared/error/interfaces/error";
import { errorInitialState, themeFormattedInitialState } from "../constants";

export type AmountAnchor = "send" | "receive";

export interface IAmountState {
  /** Pinned leg amount (source ccy when anchor=send, destination when receive). */
  amount: string;
  /** Which leg `amount` is pinned to. Last-edited side wins. */
  anchor: AmountAnchor;
}

interface GlobalState {
  theme: IViewConfig;
  setTheme: (theme: IViewConfig) => void;

  linkId: string | null;
  setLinkId: (linkId: string | null) => void;

  errorState: IErrorState;
  setErrorState: (errorState: IErrorState) => void;

  amountState: IAmountState;
  setAmountState: (amountState: IAmountState) => void;
}

export const useStore = create<GlobalState>((set) => ({
  theme: themeFormattedInitialState,
  setTheme: (theme) => {
    set(() => ({ theme }));
  },

  linkId: null,
  setLinkId: (linkId) => {
    set(() => ({ linkId }));
  },

  errorState: errorInitialState,
  setErrorState: (errorState) => {
    set(() => ({ errorState }));
  },

  amountState: { amount: "", anchor: "send" },
  setAmountState: (amountState) => {
    set(() => ({ amountState }));
  },
}));
